import { z } from 'zod';

export const CodeEnforcementCaseExtensionDefinitionScalarFieldEnumSchema = z.enum(['caseExtensionId','cityId','fieldName','defaultValue','requiredMsg','rowTimestamp']);

export default CodeEnforcementCaseExtensionDefinitionScalarFieldEnumSchema;
